// removed by extract-text-webpack-plugin
module.exports = {"main":"#56145a","menuActiveText":"#56145a","menuBg":"#304156","menuHover":"#001528","menuText":"rgba(0,0,0,0.85)","sideBarWidth":"235px","subMenuActiveText":"#56145a","subMenuBg":"#1f2d3d","subMenuHover":"rgba(0,0,0,0.03)"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 45